import { useContext } from 'react';
import { SidebarMenuCollapsibleContext } from '../SidebarMenuCollapsible';
export const useSidebarMenuCollapsible = () => {
    const context = useContext(SidebarMenuCollapsibleContext);
    if (!context) {
        throw new Error('useSidebarMenuCollapsible must be used as a child to <SidebarMenuCollapsible />');
    }
    return context;
};
